import Icons from "@/assets";

export const ROLES = {
  CONTRIBUTOR: "contributor",
  MODERATOR: "moderator",
  USER: "user",
} as const;

export type FilterCategory = {
  label: string;
  subCategories: string[];
  radius: number;
  icon: string;
};

export const FILTER_CATEGORIES: FilterCategory[] = [
  {
    label: "Restaurants",
    subCategories: [
      "restaurant",
      "indian_restaurant",
      "chinese_restaurant",
      "italian_restaurant",
      "japanese_restaurant",
      "fast_food_restaurant",
      "buffet_restaurant",
      "seafood_restaurant",
      "sushi_restaurant",
    ],
    radius: 3000,
    icon: Icons.RestaurantFilter,
  },
  {
    label: "Schools",
    subCategories: [
      "school",
      "preschool",
      "primary_school",
      "secondary_school",
    ],
    radius: 5000,
    icon: Icons.SchoolFilter,
  },
  {
    label: "Colleges",
    subCategories: ["university"],
    radius: 5000,
    icon: Icons.CollegeFilter,
  },
  {
    label: "Workplaces",
    subCategories: [
      "corporate_office",
      "advertising_agency",
      "consulting_firm",
      "employment_agency",
      "insurance_agency",
      "lawyer",
      "notary",
      "real_estate_agency",
      "tax_consultant",
    ],
    radius: 5000,
    icon: Icons.WorkPlaceFilter,
  },
  {
    label: "Airport",
    subCategories: ["international_airport", "airport"],
    radius: 25000,
    icon: Icons.AirportFilter,
  },
  {
    label: "Metro",
    subCategories: ["subway_station"],
    radius: 7000,
    icon: Icons.MetroFilter,
  },
  {
    label: "Railway Stations",
    subCategories: ["train_station"],
    radius: 10000,
    icon: Icons.RailwayFilter,
  },
];

export type RoleType = (typeof ROLES)[keyof typeof ROLES];

export const PHOTO_VIEWS = ["front", "side", "wide"];
